import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import styles from './Catalog.scss';
import * as actions from 'src/redux/catalogActions';
import Media from 'react-responsive';
import CatalogHeader from './elements/CatalogHeader.jsx';
import ModificationsTable from './elements/ModificationsTable.jsx';
import {getIdByURL} from 'src/logic/utils';
import {filter} from 'lodash';


export class Modifications extends Component {
  constructor(props, context) {
    super(props, context);
    const modelId = getIdByURL();
    props.getModifications(modelId);
  }
  render() {
    return this.props.children || (
        <div className={styles.Catalog}>
          <Media query="(min-width: 1025px)">
            <CatalogHeader
              whatIsIt="Модификации"
              showFilter={true}
              routes={this.props.routes} />
          </Media>
          <Media query="(max-width: 1024px)">
            <h2 style={{width: '100%', marginTop: '1rem',marginLeft: '1rem'}}>Модификация</h2>
          </Media>
          <ModificationsTable
            modificationList={this.props.modificationList} />
        </div>
    );
  }
}

Modifications.routeTitle = "Модификации";


export default connect(
  (state) => ({...state.catalogReducer}),
  (dispatch) => ({...bindActionCreators(actions, dispatch)})
)(Modifications);



/** WEBPACK FOOTER **
 ** ./src/components/Catalog/Modifications.jsx
 **/